import { IOrderServiceItem } from '@wyz/types';
import { Text } from '@wyz/ui';
import { ExtraServiceItem } from '~/purchase/components';

type Props = {
  serviceItem: IOrderServiceItem;
  currency: string;
};
const ServiceItem = ({ serviceItem, currency }: Props) => {
  return (
    <>
      <ExtraServiceItem
        item={{
          quantity: serviceItem.quantity,
          unitPrice: serviceItem.priceCustomer,
          discount: serviceItem.discount,
          total: serviceItem.excludedTaxesAmount,
        }}
        currency={currency}
      >
        <Text
          color='tertiary'
          weight='bold'
          heading='normal'
          className='flex-grow-1'
          id='service-type'
        >
          {serviceItem.translatedDescription ?? serviceItem.description}
        </Text>
      </ExtraServiceItem>
    </>
  );
};

export default ServiceItem;
